import type { HubPlanetDto, HubVelocityDto } from '@aiai/shared';

export type VelocityTier = 'fast' | 'steady';

/** `fast` under an hour, `steady` under a day, else none. Needs at least one shipment this week. */
export function velocityTier(v: HubVelocityDto | undefined): VelocityTier | null {
  if (!v || v.shipped7d < 1 || v.leadMinutesMedian7d == null) return null;
  if (v.leadMinutesMedian7d < 60) return 'fast';
  if (v.leadMinutesMedian7d < 24 * 60) return 'steady';
  return null;
}

/** "~45 min" under an hour, "~5 h" under 48 h, else "~2 d". */
export function formatLead(minutes: number): string {
  if (minutes < 60) return `~${Math.round(minutes)} min`;
  if (minutes < 48 * 60) return `~${Math.round(minutes / 60)} h`;
  return `~${Math.round(minutes / 1440)} d`;
}

/** The single quickest launch of the week across planets. */
export function fastestLaunch(planets: HubPlanetDto[]): { code: string; minutes: number } | null {
  let best: { code: string; minutes: number } | null = null;
  for (const p of planets) {
    const f = p.velocity?.fastest7d;
    if (!f || (best && f.minutes >= best.minutes)) continue;
    best = { code: f.issueCode ?? p.code ?? p.name, minutes: f.minutes };
  }
  return best;
}
